export enum OrganizerSharedCalendarViewEnum {
  Months = 'months',
  Weeks = 'weeks',
  Days = 'days',
  List = 'list',
}
